export default {
    listagem: {
        titulo_pagina: 'Audit Logs'
    },
    filtro: {
        evento: 'Event',
        modelo: 'Model',
        chave_modelo: 'Model Key',
        veus_id: 'Veus Id',
        usuario: 'User',
        periodo_padrao: 'Standard Period',
        periodo_personalizado: 'Custom Period',
        mais_filtros: 'More Filters',
        filtrar_button: 'Filter',
        limpar_button: 'Clear Filters'
    },
    periodos: {
        trinta_minutos: '30 minutes ago',
        uma_hora: '1 hour ago',
        hoje: 'Today',
        sete_dias: 'Last 7 days',
        mes_atual: 'Current month',
        mes_anterior: 'Last month',
        ano_atual: 'Current year',
        ano_anterior: 'Last year'
    },
    tabela: {
        campos: {
            evento: 'Event',
            modelo: 'Model',
            chave_modelo: 'Model Key',
            veus_id: 'Veus Id',
            usuario: 'User',
            criado_em: 'Created At',
            atualizado_em: 'Updated At',
            valores_antigos: 'Old Values',
            novos_valores: 'New Values',
            ip: 'IP',
            user_agent: 'User Agent',
            url: 'URL',
            tags: 'Tags'
        }
    },
    detail: {
        titulo_pagina: 'Audit Logs'
    }
}
